import VueScrollTo from 'vue-scrollto';

import { SCROLL_OPTIONS } from '@d-shared/config';

class ScrollHandler {
  scrollTo(elementSelector, offset = null) {
    const element = document.querySelector(elementSelector);
    if (!element) {
      return;
    }

    const scrollOptions = Object.assign({}, SCROLL_OPTIONS);

    if (offset) {
      scrollOptions.offset = offset;
    }

    VueScrollTo.scrollTo(element, scrollOptions);

    if (element.id) {
      history.replaceState(undefined, undefined, `#${element.dataset.id}`);
    }
  }
}


export default {
  install: function(Vue, options) {
    Vue.prototype.scrollHandler = new ScrollHandler();
  },
};
